import axios from 'axios';

export function adminUpdateCampaignScreens(adId, payload, token) {
    return axios.put(
        `${process.env.REACT_APP_API_URL}/admin/advertisements/${adId}/screens`,
        payload,
        {
            headers: {
                Authorization: `${token}`,
            },
        }
    );
}
